function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_trash_alt02"), /*#__PURE__*/React.createElement("path", {
  d: "M99.2 106.3h28.3v127.6H99.2zM155.9 106.3h28.3v127.6h-28.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248 56.7h-70.9V28.3h-70.9v28.3H35.4V85h7.1v198.4h198.4V85h7.1V56.7zm-35.4 198.2H70.9V85h141.7v169.9z"
})));